// extracted by mini-css-extract-plugin
export default {"wrapper":"CyberSportLiveCategoryEvents_wrapper--S1w","empty":"CyberSportLiveCategoryEvents_empty--DFb","label":"CyberSportLiveCategoryEvents_label--tew"};